// src/views/profile.js

import { React, useState, useEffect, Fragment, useContext } from 'react';

import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { Loading, ProfileForm, ProfileForm2 } from '../components';
import { NotaryManageProfile } from '../components/profile';
import { RestHelper } from '../helper/restHelper';
import { UserContext } from "../app"

const ProfileDetails = () => {
    const [message, setApiRes] = useState([])
    const {userProfile, setUser } = useContext(UserContext)
    const [isNotary, setIsNotary] = useState(false)
    const { user } = useAuth0();
    const { email } = user;
    const profileEmail = {'profileEmail' : email}
    const api = RestHelper()
    const options = {}
    
    
    useEffect (() => {
      if (userProfile.profileRole == 'notary') {
        setIsNotary(true)
      }  
      getProfile();
      }, []);
    
    const getProfile = () => {
    api
    .postCreate('/get-profile-details', options, profileEmail)
    .then(res => setApiRes(res))
    .catch(err => console.log(err))
    }

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        const cleaned = phone.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0,3)}) ${cleaned.slice(3,6)}-${cleaned.slice(6)}`;
        }
        return phone;
    }



  return (
<div>
    {isNotary
    ? (
    <Fragment>
    <NotaryManageProfile/>
    </Fragment>)
    :
    <div className="max-w-2xl mx-auto">
        {message.map((items =>
            <div key={items.profileEmail} className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-neutral-100 bg-gradient-to-r from-blue-600 to-blue-700">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                        </div>
                        <div>
                            <h2 className="text-lg font-semibold text-white">{items.profileName}</h2>
                            <p className="text-blue-100 text-sm">{items.profileOrganization}</p>
                        </div>
                    </div>
                </div>
                <div className="p-6">
                    <h3 className="text-lg font-semibold text-neutral-800 mb-4">Profile Information</h3>
                    <div className="space-y-1">
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Name</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.profileName}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Organization</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.profileOrganization}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Role</div>
                            <div className="sm:col-span-2">
                                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 capitalize">
                                    {items.profileRole}
                                </span>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-neutral-100">
                            <div className="font-medium text-neutral-600">Phone Number</div>
                            <div className="sm:col-span-2 text-neutral-800">{formatPhoneNumber(items.profilePhone)}</div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3">
                            <div className="font-medium text-neutral-600">E-mail</div>
                            <div className="sm:col-span-2 text-neutral-800">{items.profileEmail}</div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
    </div>}
</div>
  );
};

export default ProfileDetails;